import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { getUserData, generateGoogleWalletPass } from '../services/api';
import Loading from './Loading';

const WalletContainer = styled.div`
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const UserInfo = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
`;

const StatusMessage = styled.div`
  margin: 1.5rem 0;
  padding: 1rem;
  border-radius: 4px;
  background-color: ${props => props.success ? '#d4edda' : '#f8d7da'};
  color: ${props => props.success ? '#155724' : '#721c24'};
`;

const Button = styled.a`
  display: inline-block;
  background-color: #4285F4;
  color: white;
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 1rem;

  &:hover {
    background-color: #3367d6;
  }
`;

const GoogleWallet = () => {
  const { userId } = useParams();
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [walletPass, setWalletPass] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      // ดึงข้อมูลผู้ใช้
      const userResult = await getUserData(userId);
      if (userResult.success) {
        setUserData(userResult.data);

        // สร้าง Google Wallet Pass
        const passResult = await generateGoogleWalletPass(userId);
        if (passResult.success) {
          setWalletPass(passResult);
        } else {
          setStatus({
            success: false,
            message: passResult.message
          });
        }
      } else {
        setStatus({
          success: false,
          message: userResult.message
        });
      }

      setLoading(false);
    };

    fetchData();
  }, [userId]);

  if (loading) {
    return (
      <WalletContainer>
        <h2>กำลังสร้าง Google Wallet Pass...</h2>
        <Loading />
      </WalletContainer>
    );
  }

  return (
    <WalletContainer>
      <h1>Google Wallet Pass</h1>

      {userData ? (
        <UserInfo>
          <h2>{userData.displayName}</h2>
          <p><strong>งาน:</strong> Linx OpenHouse</p>
          <p><strong>วันที่:</strong> 15 ธันวาคม 2566</p>
          <p><strong>สถานที่:</strong> Linx Lab Office</p>
        </UserInfo>
      ) : (
        <StatusMessage success={false}>
          <p>ไม่พบข้อมูลผู้ใช้</p>
        </StatusMessage>
      )}

      {status && (
        <StatusMessage success={status.success}>
          <p>{status.message}</p>
        </StatusMessage>
      )}

      {walletPass && (
        <div>
          <p>คลิกที่ปุ่มด้านล่างเพื่อดาวน์โหลดและเพิ่ม Pass ลงใน Google Wallet ของคุณ</p>
          <Button
            href={walletPass.data}
            download={walletPass.filename}
          >
            เพิ่มใน Google Wallet
          </Button>
        </div>
      )}
    </WalletContainer>
  );
};

export default GoogleWallet;
